<script lang="ts">
    import type {DurationItem} from '../types';
    import {tooltip} from 'shared/ui-widgets/tooltip/use.tooltip';
    import {exists} from 'shared/utils/custom-utils';
    import {isDescriptedDurationItem} from '../utils';
    import DurationItemFormat from './DurationItemFormat.svelte';

    export let durationItem: DurationItem | null = null;
    export let header = false;
    export let topBordered = false;
</script>

<div class="attendance-calendar-cell"
     class:header-cell={header}
     class:top-bordered-cell={topBordered}
     class:errored-cell={isDescriptedDurationItem(durationItem) && exists(durationItem.errorDescription)}
     use:tooltip={{enabled: isDescriptedDurationItem(durationItem), content: isDescriptedDurationItem(durationItem) ? (durationItem.errorDescription ?? durationItem.description) : '', role: 'tooltip'}}>

    <DurationItemFormat {durationItem}/>

    {#if exists($$slots.default)}
        <slot/>
    {/if}
</div>

<style lang="less">
    @import (reference) "styles/portaro.variables.less";
    @import (reference) "styles/portaro.themes.less";

    .attendance-calendar-cell {
        display: flex;
        padding: 0 @spacing-xs;
        align-items: center;
        text-align: center;
        white-space: nowrap;
        justify-content: center;
        line-height: 1;
        height: 28px;

        &.header-cell {
            font-weight: 500;
            border-bottom: 1px solid @themed-border-default;
        }

        &.errored-cell {
            background-color: @themed-body-bg-red-highlighted;
            color: var(--danger-red);
        }

        &.top-bordered-cell {
            border-top: 1px solid @themed-border-default;
        }

        &:not(.header-cell) {
            transition: background-color 0.3s ease-in-out;

            &:hover {
                background-color: @themed-panel-bg;
            }
        }
    }
</style>